import { cn } from '@/components/ui/cn';
import { Stack } from '@/components/ui/layout';
import { BrandMark } from '@/features/branding/brand-mark';
import layoutStyles from './onboarding-logo-header.layout.module.css';

import { WarningBanner } from '../warning-banner';

/**
 * Invite-token onboarding header. Cheap to swap because BrandMark already
 * falls back to MinervaLogo when unbound. `/login` stays Minerva because
 * public routes never pass tenant branding into RuntimeProviders (RFC U3).
 */
export function OnboardingLogoHeader() {
  return (
    <>
      <Stack className={cn(layoutStyles.layout1)}>
        <Stack className={'flex flex-row items-center gap-2'}>
          <BrandMark className="my-2 h-20 w-36" />
        </Stack>
      </Stack>
      <WarningBanner />
    </>
  );
}
